export enum View {
    Assessment = "assessment",
    Language = "language",
    Privacy = "privacy",
    Profile = "profile",
    Notifications = "notifications",
    TemporaryAccess = "temporaryAccess",
    ExternalServices = "externalServices"
}
